import { Auth } from 'aws-amplify';

// Who the signed-in user is, for attributing a record they create (CP-836 guardrail 3).
//
// Why this is not just `user.attributes.email`: CP admin roles arrive through Okta federation, and
// for a federated user Amplify resolves currentAuthenticatedUser() WITHOUT populating
// `.attributes`. Reading the email from there alone yields '' for exactly the users most likely to
// be using an admin screen. Two features shipped that way and recorded a blank author on every
// single row they wrote — AiPrompt (prompt versions) and AiClientQualificationDocument (uploaded
// qualification PDFs), in both dev and staging.
//
// The ID token claims are this repo's established source for a user's email (see App.js,
// Login, ClientAccess/EditAccess and ExpenseEntry/DriverSolutions/*, which all read
// signInUserSession.idToken.payload). Fall back through it, then to the Cognito username, so the
// caller records something identifying rather than nothing.
//
// The two lookups are independent on purpose: either can fail without costing us the other, and
// neither failing may block the caller's write — attribution is metadata, not a precondition.
export const currentUserIdentity = async () => {
  let user = null;
  let claims = {};
  try {
    user = await Auth.currentAuthenticatedUser();
  } catch (e) {
    // Message first: JSON.stringify of an Error is "{}", which is what kept the blank-author bug
    // invisible in the console.
    console.log(`Error resolving the current user: ${e?.message || JSON.stringify(e)}`);
  }
  try {
    claims = (await Auth.currentSession()).getIdToken().payload || {};
  } catch (e) {
    console.log(`Error resolving the current user's claims: ${e?.message || JSON.stringify(e)}`);
  }
  const email = user?.attributes?.email || claims.email || user?.username || claims['cognito:username'] || '';
  const fullName =
    [user?.attributes?.given_name, user?.attributes?.family_name].filter(Boolean).join(' ') ||
    [claims.given_name, claims.family_name].filter(Boolean).join(' ') ||
    claims.name ||
    '';
  return { email, fullName };
};

export default currentUserIdentity;
